import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDOPhGihAknPUtM6-SV9dz4mVaDtN5hQkQ",
  authDomain: "blog-sadnapoleon-271a3.firebaseapp.com",
  projectId: "blog-sadnapoleon-271a3",
  storageBucket: "blog-sadnapoleon-271a3.appspot.com",
  messagingSenderId: "533118903158",
  appId: "1:533118903158:web:47e7bf1ec94b33ae395057",
  measurementId: "G-KGY97N1C9L"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;
